// extracted by mini-css-extract-plugin
module.exports = {"footer":"page-footer_footer__GSenq","logo":"page-footer_logo___L_Q6","logoContainer":"page-footer_logoContainer__GZx7n"};